/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { deployVersionGet } from '../fn/deployment/deploy-version-get';
import { DeployVersionGet$Params } from '../fn/deployment/deploy-version-get';

@Injectable({ providedIn: 'root' })
export class DeploymentService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `deployVersionGet()` */
  static readonly DeployVersionGetPath = '/deploy-version';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deployVersionGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  deployVersionGet$Response(params?: DeployVersionGet$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    const obs = deployVersionGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deployVersionGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deployVersionGet(params?: DeployVersionGet$Params, context?: HttpContext): Observable<string> {
    const resp = this.deployVersionGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

}
